import {BBModel} from '../../bb_model';
import {BaseModel} from '../base';
import {itemDetails} from '../../services/item_details';
import {BBService} from '../../bb_service';

class ItemDetailsModel extends BaseModel {

    constructor(data) {
        super(data);
        this._data = data;

        if (this._data) {
            this.self = this._data.$href('self');
        }

        this.questions = [];
        this.survey_questions = [];

        if (data) {
            for (const q of Array.from(data.questions)) {
                if ((q.outcome) === false) {
                    if (data.currency_code) {
                        q.currency_code = data.currency_code;
                    }
                    this.questions.push(new BBModel.Question(q));
                } else {
                    this.survey_questions.push(new BBModel.SurveyQuestion(q));
                }
            }
        }

        this.questions = BBService.question.groupConditionalQuestions(this.questions);

        this.hasQuestions = (this.questions.length > 0);
        this.hasSurveyQuestions = (this.survey_questions.length > 0);
    }

    /**
     * @description
     * Get total price of all the question included in the given object.
     *
     * @returns {number} Total price.
     */
    questionPrice(quantity = 1) {
        return this.questions.reduce((price, question) => price + question.selectedPriceQty(quantity), 0);
    }

    /**
     * @ngdoc method
     * @name setAnswersFromQuestions
     * @methodOf BB:ItemDetails
     * @description
     * Set answers of the item details questions.
     */
    setAnswers(answers) {
        BBService.question.fillQuestionsWithAnswers(this.questions, answers);
    }

    /**
     * @ngdoc method
     * @name setAnswersFromQuestions
     * @methodOf BB:ItemDetails
     * @description
     * Set answers of the item details in function of answers.
     */
    setAnswersFromQuestions(questions) {
        const answers = BBService.question.getAnswers(questions);
        BBService.question.fillQuestionsWithAnswers(this.questions, answers);
    }

    /**
     * @ngdoc method
     * @name sortQuestions
     * @methodOf BB:ItemDetails
     *
     * @param settings Company settings object helping to determine how questions should be sorted.
     *
     * @description
     * Sorts questions in a proper order depending on the company settings.
     */
    sortQuestions(settings) {
        // If company does not have questions groups it means we have to sort them by position. They are already
        // sorted by the API otherwise.
        if (settings && !settings.has_question_groups) {
            this.questions = BBService.question.sortQuestionsAccordingToPosition(this.questions);
        }
    }

    /**
     * @ngdoc method
     * @name getQuestion
     * @methodOf BB:ItemDetails
     * @description
     * Get booking question with the given id.
     *
     * @returns {object} The returned question model.
     */
    getQuestion(id) {
        return this.questions.find(question => question.id === id);
    }

    /**
     * @description
     * Get data
     *
     * @returns {array} The returned data
     */
    getPostData() {
        return BBService.question.unwrapGroupedQuestions(this.questions)
            .filter(question => question.currentlyShown).map(question => question.getPostData())
            .filter(question => question.answer);
    }

    static $query(prms) {
        return itemDetails.query(prms);
    }
}

export {
    ItemDetailsModel
};
